import AccDetails from './AccDetails';
import AdroitChequesModal from './AdroitChequesModal';
import ApprovalRequiredModal from './ApprovalRequiredModal';
import ApiUsersRefundModal from './ApiUsersRefundModal';
import BroadcastNotificationModal from './Campaigns/BroadcastNotification/BroadcastNotificationModal';
import CampaignModal from './CampaignModal';
import CreateMerchantModal from './CreateMerchantModal';
import EditCareerModal from './Careers/EditCareerModal';
import EditSurveyModal from './EditSurveyModal';
import GenAccountModal from './GenAccountModal';
import GenerateModal from './GenerateModal';
import OtpModal from './OtpModal';
import PromotionModal from './PromotionModal';
import QMcashModal from './QMcashModal';
import React from 'react';
import RefunWalletModal from './RefunWalletModal';
import RegenerateModal from './RegenerateModal';
import SendPushNotificationModal from './SendPushNotificationModal';
import SessionModal from './SessionModal';
import SupervisorLogsModal from './SupervisorLogsModal';
import SupervisorWalletModal from './SupervisorWalletModal';
import SurveyResponseModal from './SurveyResponseModal';
import TransactionsModal from './TransactionModal';
import UpdateBalanceModal from './UpdateBalanceModal';
import UserModal from './UserModal';

export default () => (
  <div>
    <TransactionsModal />
    <GenerateModal />
    <RegenerateModal />
    <UserModal />
    <QMcashModal />
    <GenAccountModal />
    <SupervisorWalletModal />
    <SupervisorLogsModal />
    <SessionModal />
    <RefunWalletModal />
    <SendPushNotificationModal />
    <AccDetails />
    <AdroitChequesModal />
    <ApiUsersRefundModal />
    <CreateMerchantModal />
    <UpdateBalanceModal />
    <CampaignModal />
    <BroadcastNotificationModal />
    <SurveyResponseModal />
    <EditSurveyModal />
    <PromotionModal />
    <EditCareerModal />
    <ApprovalRequiredModal />
    <OtpModal />
  </div>
);
